import { Box, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment-timezone'

const PurchaseOrderTable = () => {
    const purchaseOrder = useSelector(state => state.common?.purchaseOrder)
    const buildingTimezone = useSelector(state => state.common?.buildingTimezone)

    const formatDate = (dateString) => {
        if (!dateString) return null
        const timezone = buildingTimezone?.tzCode || 'UTC'
        return moment(dateString).tz(timezone).format('MMM DD, YYYY')
    }

    // Build table data conditionally
    const tableData = [
        { label: 'PO Code', value: purchaseOrder?.poCode || 'N/A' },
        { label: 'Vendor', value: purchaseOrder?.vendor?.name || 'N/A' },
        { label: 'Items Ordered', value: purchaseOrder?.inventoryItems || 'N/A' },
        { label: 'Approvers', value: purchaseOrder?.approvers?.map(approver => approver?.name).join(', ') || 'N/A' },
        { label: 'Created Date', value: formatDate(purchaseOrder?.createdDate) || 'N/A' },
        { label: 'Created By', value: purchaseOrder?.createdBy?.name || 'N/A' },
    ]

    // Only add Expected Delivery if it exists
    const expectedDelivery = formatDate(purchaseOrder?.expectedDeliveryDate)
    if (expectedDelivery) {
        tableData.push({ label: 'Expected Delivery', value: expectedDelivery })
    }

    return (
        <Box sx={{
            width: '100%',
            maxWidth: { xs: '100%', sm: '500px', md: '580px' }
        }}>
            <TableContainer sx={{
                backgroundColor: '#fafbfc',
                borderRadius: '16px',
                overflow: 'hidden',
                border: '1px solid #e1e4e8',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
            }}>
                <Table sx={{ minWidth: 500 }}>
                    <TableBody>
                        {tableData.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    '&:nth-of-type(even)': {
                                        backgroundColor: '#ffffff'
                                    },
                                    '&:hover': {
                                        backgroundColor: '#f6f8fa'
                                    },
                                    transition: 'background-color 0.2s ease'
                                }}
                            >
                                <TableCell
                                    sx={{
                                        fontWeight: 600,
                                        borderBottom: index === tableData.length - 1 ? 'none' : '1px solid #e1e4e8',
                                        padding: { xs: '14px 16px', md: '18px 24px' },
                                        width: '40%',
                                        color: '#24292e',
                                        fontSize: { xs: '0.875rem', md: '0.95rem' },
                                        letterSpacing: '0.2px'
                                    }}
                                >
                                    {row.label}
                                </TableCell>
                                <TableCell
                                    sx={{
                                        borderBottom: index === tableData.length - 1 ? 'none' : '1px solid #e1e4e8',
                                        padding: { xs: '14px 16px', md: '18px 24px' },
                                        color: '#586069',
                                        fontSize: { xs: '0.875rem', md: '0.95rem' },
                                        fontWeight: 500,
                                        wordBreak: row.label === 'Approvers' ? 'break-word' : 'normal'
                                    }}
                                >
                                    {row.value}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default PurchaseOrderTable
